import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Checkbox,
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Spin,
  Typography,
  Upload,
} from "antd";

import {
  SettingOutlined,
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import {
  updateOrganization,
  updateServiceTypeOfferings,
  updateTradeOfferings,
} from "../../redux/organizationSlice";
import { TradeIcons } from "../../utils/tradeIcons";
import { getBase64, icons } from "../../utils/constants";
import SaveButton from "../UI/savebutton";

const { Title, Text } = Typography;

const TradeServiceOfferings = () => {
  const htmlRef = useRef(document.querySelector("html"));
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [tradeLogos, setTradeLogos] = useState([]);
  const [servicesLogos, setServicesLogos] = useState([]);
  const [Dirty, setDirty] = useState(false);

  const { organizationData, loading } = useSelector(
    (state) => state?.organization
  );
  const { trades, services } = useSelector((state) => state.trade);

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  useEffect(() => {
    if (organizationData?.trades_logo) {
      setTradeLogos(organizationData?.trades_logo || []);
    }
    if (organizationData?.services_logo) {
      setServicesLogos(organizationData?.services_logo || []);
    }
    htmlRef?.current?.style.setProperty(
      "--primary-color",
     organizationData?.primaryColor
    );
    htmlRef?.current?.style.setProperty(
      "--primary-color",
     organizationData?.primaryColor
    );
    
  }, [organizationData]);

  const onChangeTrade = (trade, value) => {
    dispatch(updateTradeOfferings({ trade, value }));
    setDirty(true);
  };

  const onChangeServiceType = (trade, serviceType, value) => {
    dispatch(updateServiceTypeOfferings({ trade, serviceType, value }));
    setDirty(true);
  };

  const handleSubmit = () => {
    const payload = {
      navigation_mapping: organizationData?.navigation_mapping,
      trade_logos: tradeLogos,
      service_logos: servicesLogos,
    };
    dispatch(updateOrganization({ id: organizationData._id, payload,page: "Trades & Service Offerings" }));
    setDirty(false);
  };

  const handleTradeLogosChange = async ({ fileList }, tradeData, tradeName) => {
    const updatedLogos = tradeLogos.filter(
      (item) => item.tradeId !== tradeData?._id
    );

    if (fileList.length > 0) {
      const newFiles = await Promise.all(
        fileList.map(async (file) => {
          const preview = await getBase64(file.originFileObj);
          file["preview"] = preview;
          return {
            tradeId: tradeData?._id,
            tradeName,
            name: tradeData?.tradeName,
            ...file,
          };
        })
      );
      updatedLogos.push(...newFiles);
    }
    setDirty(true);
    setTradeLogos(updatedLogos);
  };
  const handleServiceLogosChange = async (
    { fileList },
    serviceData,
    serviceName
  ) => {
    const updatedLogos = servicesLogos.filter(
      (item) => item.serviceId !== serviceData?._id
    );
    let filteredList = [];
    const existingLogo = servicesLogos.find(
      (item) => item.serviceId === serviceData?._id
    );
    if (existingLogo) {
      filteredList = fileList.filter((item) => item.uid !== existingLogo.uid);
    } else {
      filteredList = fileList;
    }
    const newFiles = await Promise.all(
      filteredList.map(async (file) => {
        const preview = await getBase64(file.originFileObj);
        file["preview"] = preview;
        return {
          serviceId: serviceData?._id,
          serviceName,
          name: serviceData?.name,
          ...file,
        };
      })
    );
    updatedLogos.push(...newFiles);
    setDirty(true);
    setServicesLogos(updatedLogos);
  };

  const handleDeleteTradeLogo = (tradeId) => {
    const updatedLogos = tradeLogos.filter(
      (item) => item.tradeId !== tradeId
    );
    setTradeLogos(updatedLogos);
    setDirty(true);
  };

  const handleDeleteServiceLogo = (serviceId) => {
    const updatedLogos = servicesLogos.filter(
      (item) => item.serviceId !== serviceId
    );
    setServicesLogos(updatedLogos);
    setDirty(true);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleCancel = () => setPreviewOpen(false);
  return (
    <>
     <style>
       {`
       .icon_otr-service svg path {
          fill: var(--primary-color);
        }
       `}
     </style>
      <Spin spinning={loading} tip="Loading..." fullscreen />
      <div
        style={{
          padding: "30px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{ display: "flex", gap: 8, alignItems: "center" }}
          className="settings-header"
        >
          <img
            src={require("../../assets/Images/wrench.jpg")}
            height={22}
            width={22}
            alt="map-logo"
            style={{
              verticalAlign: "middle",
              display: "inline-block",
            }}
          />
          <Title level={3} style={{ margin: 0, marginBottom: 16 }}>
            Trades and Service Offerings
          </Title>
        </div>
        <br />
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            backgroundColor: "#f9f9f9",
            padding: "24px",
            borderRadius: "12px",
          }}
          autoComplete="new-state"
        >
        <Row gutter={[32, 32]}>
          {organizationData?.navigation_mapping?.map((trade) => {
            const tradeData = trades.find(
              (item) => item.tradeName === trade?.trade?.name
            );
            const tradeUrl =
              tradeLogos?.find((Logo) => Logo.tradeId === tradeData?._id)
                ?.url ||
              tradeLogos?.find((Logo) => Logo.tradeId === tradeData?._id)
                ?.preview;
            const TradeIcon = tradeUrl ? (
              <div style={{ position: "relative", width: "60px", height: "60px" }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "12px",
                    border: "2px solid #f0f0f0",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                  src={tradeUrl}
                  alt={trade?.trade?.name}
                  className="trade-icon"
                />
                <EditOutlined
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    borderRadius: "50%",
                    color: "#fff",
                    fontSize: "12px",
                    padding: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                />
                <DeleteOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteTradeLogo(tradeData?._id);
                  }}
                  style={{
                    position: "absolute",
                    top: "-6px",
                    left: "-6px",
                    backgroundColor: "rgba(255, 77, 79, 0.9)",
                    borderRadius: "50%",
                    color: "#fff",
                    fontSize: "12px",
                    padding: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "rgba(255, 77, 79, 1)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "rgba(255, 77, 79, 0.9)")
                  }
                />
              </div>
            ) : TradeIcons[trade?.trade?.name] ? (
              <div style={{ 
                position: "relative",
                width: "60px", 
                height: "60px", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                border: "2px solid #e9ecef",
              }}>
                <div style={{ fontSize: "24px" }}>
                  {TradeIcons[trade?.trade?.name]?.icon()}
                </div>
                <EditOutlined
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    borderRadius: "50%",
                    color: "#fff",
                    fontSize: "12px",
                    padding: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                />
              </div>
            ) : (
              <div 
                style={{ 
                  width: "60px", 
                  height: "60px", 
                  display: "flex", 
                  flexDirection: "column",
                  alignItems: "center", 
                  justifyContent: "center", 
                  border: "2px dashed #d9d9d9", 
                  borderRadius: "12px",
                  backgroundColor: "#fafafa",
                  transition: "all 0.3s ease",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#1890ff";
                  e.currentTarget.style.backgroundColor = "#f6f8ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#d9d9d9";
                  e.currentTarget.style.backgroundColor = "#fafafa";
                }}
              >
                <PlusOutlined style={{ fontSize: "16px", color: "#1890ff", marginBottom: "2px" }} />
                <span style={{ fontSize: "8px", color: "#1890ff", fontWeight: "500" }}>Upload</span>
              </div>
            );

            return (
              <React.Fragment key={trade?.trade?.id}>
                <Col span={12} sm={24} md={12} lg={12} style={{paddingRight: "12px" }}>
                                     <div 
                     style={{ 
                       display: "flex", 
                       alignItems: "flex-start", 
                       gap: "10px",
                       padding: "16px",
                       backgroundColor: "#fff",
                       borderRadius: "8px",
                       border: "1px solid #f0f0f0",
                       boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                       transition: "all 0.3s ease",
                       cursor: "pointer"
                     }}
                     onMouseEnter={(e) => {
                       e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
                       e.currentTarget.style.transform = "translateY(-2px)";
                     }}
                     onMouseLeave={(e) => {
                       e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                       e.currentTarget.style.transform = "translateY(0)";
                     }}
                   >
                    <div style={{ flexShrink: 0 }}>
                      <Upload
                        action="https://file.io"
                        listType="picture-card"
                        fileList={tradeLogos?.filter(
                          (item) => item?.tradeId === tradeData?._id
                        )}
                        beforeUpload={() => false}
                        onPreview={handlePreview}
                        onChange={(e) =>
                          handleTradeLogosChange(e, tradeData, trade?.trade?.name)
                        }
                        maxCount={1}
                        style={{ textAlign: "center" }}
                        showUploadList={false}
                      >
                        {TradeIcon}
                      </Upload>
                      <Modal
                        open={previewOpen}
                        title={previewTitle}
                        footer={null}
                        onCancel={handleCancel}
                      >
                        <img
                          alt="organization_logo"
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                          src={previewImage}
                        />
                      </Modal>
                    </div>
                    
                    <div style={{ flex: 1 }}>
                      <div className="trade-offering" style={{ marginBottom: "16px" }}>
                        <Checkbox
                          checked={trade?.isActive}
                          onChange={(e) =>
                            onChangeTrade(trade?.trade?.name, e.target.checked)
                          }
                          style={{ fontSize: "16px" }}
                        >
                          <Text strong style={{ fontSize: "18px", color: "#262626" }}>
                            {trade?.trade?.name}
                          </Text>
                        </Checkbox>
                      </div>
                      
                      <div
                        className="service-type-checkboxes"
                        style={{ 
                          display: "flex", 
                          flexWrap: "wrap", 
                          gap: "12px 16px",
                          marginTop: "12px"
                        }}
                      >
                        {[
                          ...Object.keys(trade?.offeredServiceTypes || {}).map(
                            (serviceType) =>
                              serviceType !== "additionalServices" && (
                                <Checkbox
                                  key={serviceType}
                                  checked={trade?.offeredServiceTypes[serviceType]}
                                  onChange={(e) =>
                                    onChangeServiceType(
                                      trade?.trade?.name,
                                      serviceType,
                                      e.target.checked
                                    )
                                  }
                                  disabled={!trade?.isActive}
                                  style={{ 
                                    margin: 0,
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    backgroundColor: trade?.isActive ? "#f8f9fa" : "#f5f5f5"
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      color: trade?.isActive ? "#595959" : "#bfbfbf"
                                    }}
                                  >
                                    {serviceType.charAt(0).toUpperCase() +
                                      serviceType.slice(1)}
                                  </Text>
                                </Checkbox>
                              )
                          ),
                          ...(trade?.offeredServiceTypes?.additionalServices
                            ? Object.keys(
                                trade?.offeredServiceTypes?.additionalServices
                              ).map((serviceType) => (
                                <Checkbox
                                  key={serviceType}
                                  checked={
                                    trade?.offeredServiceTypes?.additionalServices[
                                      serviceType
                                    ]
                                  }
                                  onChange={(e) =>
                                    onChangeServiceType(
                                      trade?.trade?.name,
                                      serviceType,
                                      e.target.checked
                                    )
                                  }
                                  disabled={!trade?.isActive}
                                  style={{ 
                                    margin: 0,
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    backgroundColor: trade?.isActive ? "#f8f9fa" : "#f5f5f5"
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      color: trade?.isActive ? "#595959" : "#bfbfbf"
                                    }}
                                  >
                                    {serviceType.charAt(0).toUpperCase() +
                                      serviceType.slice(1)}
                                  </Text>
                                </Checkbox>
                              ))
                            : []), // If additionalServices is not available, return an empty array
                        ]}
                      </div>
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            );
          })}
                </Row>
        </Form>
      </div>
      <Divider />
      <div
        style={{
          padding: "30px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{ display: "flex", gap: 8, alignItems: "center" }}
          className="settings-header"
        >
          <SettingOutlined style={{ fontSize: "20px" }} />

          <Title level={3} style={{ margin: 0, marginBottom: 16 }}>
            Service Types Logo
          </Title>
        </div>
        <br />
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            backgroundColor: "#f9f9f9",
            padding: "24px",
            borderRadius: "12px",
          }}
          autoComplete="new-state"
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
              gap: "20px",
            }}
          >
            {services.map((service) => {
              const serviceUrl =
                servicesLogos.find((item) => item.serviceId === service?._id)
                  ?.url ||
                servicesLogos.find((item) => item.serviceId === service?._id)
                  ?.preview;

              const serviceIcon = serviceUrl ? (
                <div
                  style={{
                    position: "relative",
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                      border: "2px solid #f0f0f0",
                    }}
                    src={serviceUrl}
                    alt={service?.name}
                    className="trade-icon"
                  />
                  <EditOutlined
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                      borderRadius: "50%",
                      color: "#fff",
                      fontSize: "12px",
                      padding: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        "rgba(0, 0, 0, 0.9)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        "rgba(0, 0, 0, 0.7)")
                    }
                  />
                  <DeleteOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteServiceLogo(service?._id);
                    }}
                    style={{
                      position: "absolute",
                      top: "-6px",
                      left: "-6px",
                      backgroundColor: "rgba(255, 77, 79, 0.9)",
                      borderRadius: "50%",
                      color: "#fff",
                      fontSize: "12px",
                      padding: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(255, 77, 79, 1)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(255, 77, 79, 0.9)")
                    }
                  />
                </div>
              ) : icons[service?.name?.toLowerCase()] ? (
                <div
                  style={{
                    position: "relative",
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    border: "2px solid #e9ecef",
                  }}
                >
                  <div className="icon_otr-service" style={{ fontSize: "32px" }}>
                    {React.createElement(icons[service?.name?.toLowerCase()])}
                  </div>
                  <EditOutlined
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                      borderRadius: "50%",
                      color: "#fff",
                      fontSize: "12px",
                      padding: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        "rgba(0, 0, 0, 0.9)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        "rgba(0, 0, 0, 0.7)")
                    }
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fafafa",
                    border: "2px dashed #d9d9d9",
                    borderRadius: "12px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "#1890ff";
                    e.currentTarget.style.backgroundColor = "#f6f8ff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#d9d9d9";
                    e.currentTarget.style.backgroundColor = "#fafafa";
                  }}
                >
                  <PlusOutlined
                    style={{ fontSize: "20px", color: "#1890ff", marginBottom: "4px" }}
                  />
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#1890ff",
                      fontWeight: "500",
                    }}
                  >
                    Upload
                  </span>
                </div>
              );

              return (
                <div 
                  key={service?._id} 
                  style={{ 
                    textAlign: "center",
                    padding: "20px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #f0f0f0",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <h3 style={{ 
                    fontWeight: "600", 
                    marginBottom: "16px", 
                    color: "#262626",
                    fontSize: "16px"
                  }}>
                    {service?.name}
                  </h3>
                  <Upload
                    action="/upload"
                    listType="picture-card"
                    showUploadList={false}
                    fileList={servicesLogos?.filter(
                      (item) => item?.serviceId === service?._id
                    )}
                    onChange={(e) =>
                      handleServiceLogosChange(e, service, service?.name)
                    }
                    beforeUpload={() => false}
                  >
                    {serviceIcon}
                  </Upload>
                </div>
              );
            })}
          </div>
        </Form>
      </div>
      <SaveButton onSubmit={handleSubmit} isDirty={Dirty} />
    </>
  );
};

export default TradeServiceOfferings;
